import {useRoutes} from "react-router-dom";
import FirstPage from "./baseTemplate/firstPage/FirstPage.tsx";
import ShrineNews from "./shrineNews/ShrineNews.tsx";
import Prayers from "./prayers/Prayers.tsx";
import ShrineInformation from "./shrineInformation/ShrineInformation";
import PilgrimageLetter from "./pilgrimageLetter/PilgrimageLetter";
import Quran from "./quran/Quran.tsx";
import VicariousPilgrimage from "./vicariousPilgrimage/VicariousPilgrimage";
import ShrineNewsDetail from "./shrineNews/shrineNewsDetail.tsx";
import ReligiousTimesBase from "./islamicTimeAndCalendar/ReligiousTimesBase";
import PilgrimServices from "./pilgrimServices/PilgrimServices";
import HaramLive from "./haramLive/HaramLive";
import MehmanSara from "./mehmanSara/MehmanSara";
import ShrineFood from "./shrineFood/ShrineFood";
import Vow from "./vow/Vow";
import Mafatih from "./mafatih/Mafatih";
import MafatihContent from "./mafatih/MafatihContent";
import CulturalAdvertising from "./culturalAdvertising/CulturalAdvertising";
import ReligiousCeremonies from "./religiousCeremonies/ReligiousCeremonies";
import ShrineCalendar from "./shrineCalendar/ShrineCalendar";
import AboutImamzadeh from "./shrineInformation/information-part/AboutImamzadeh";
import Zarih from "./shrineInformation/information-part/Zarih";
import Katibe from "./shrineInformation/information-part/katibe";
import {Architecture} from "@mui/icons-material";
import QuranPage from "./quran/QuranPage";
import Authentication from "./Authentication/Authentication.tsx";
import ServantServices from "./ServantServices/ServantServices";
import KhoddamPage from "./Khoddam/KhoddamPage.tsx";
import LiveStream from "./LiveStream/LiveStream.tsx";
import RegUser from "./regUser/RegUser.tsx";
//کامپونت های هر صفحه


const Router = () => {
    const routes = [
        {
            path: "",
            element: <FirstPage/>,
            name: 'صفحه اصلی'
        },
        {
            element: <ShrineInformation/>,
            name: 'درباره حرم',
            path: "/ShrineInformation"
        },
        {
            element: <PilgrimageLetter/>,
            name: 'زیارت نامه',
            path: "/PilgrimageLetter"
        },
        {
            element: <Quran/>,
            path: "/Quran",
            name: 'قران'
        },
        {
            element: <VicariousPilgrimage/>,
            name: 'زیارت نیابتی',
            path: "/VicariousPilgrimage"
        },
        {
            element: <ShrineNews/>,
            name: 'اخبار حرم',
            path: "/News/:newsType"
        },
        {
            element: <ShrineNews/>,
            name: 'اخبار حرم',
            path: "/News"
        },
        {
            element: <ShrineNewsDetail/>,
            name: 'اخبار حرم',
            path: "/ShrineNews/ShrineNewsDetail/:id"
        },
        {
            element: <ReligiousTimesBase/>,
            name: 'تقویم و اوقات شرعی',
            path: "/ReligiousTimesBase"
        },
        {
            element: <PilgrimServices/>,
            name: 'خدمات زائرین',
            path: "/PilgrimServices"
        },
        {
            element: <HaramLive/>,
            path: "/HaramLive",
            name: 'سیمای حرم'
        },
        {
            element: <MehmanSara/>,
            path: "/MehmanSara",
            name: ' مهمانسرا'
        },
        {
            element: <ShrineFood/>,
            path: "/ShrineFood",
            name: 'غذای حضرتی'
        },
        {
            element: <Vow/>,
            name: 'نذورات',
            path: "/Vow"
        },
        {
            element: <Mafatih/>,
            name: 'مفاتیح',
            path: "/Mafatih/:mafatihPart"
        },
        {
            element: <MafatihContent/>,
            name: 'محتوای مفاتیح',
            path: "/Mafatih/content/:id"
        },
        {
            element: <CulturalAdvertising/>,
            name: 'فرهنگی و تبلیغاتی',
            path: "/CulturalAdvertising"
        },
        {
            element: <Prayers/>,
            name: 'ادعیه و مناجات',
            path: "/Prayers"
        },
        {
            element: <ReligiousCeremonies/>,
            name: 'مراسم های مذهبی',
            path: "/ReligiousCeremonies"
        },
        {
            element: <ShrineCalendar/>,
            name: 'تقویم حرم',
            path: "/ShrineCalendar"
        },
        {
            element: <AboutImamzadeh/>,
            name: 'درباره امامزاده',
            path: "/ShrineInformation/AboutImamzadeh"
        },
        {
            element: <Zarih/>,
            name: 'ضریح',
            path: "/ShrineInformation/Zarih"
        },
        {
            element: <Katibe/>,
            name: 'کتیبه',
            path: "/ShrineInformation/Katibe"
        },
        {
            element: <Architecture/>,
            path: "/ShrineInformation/Architecture",
            name: 'ورودی'
        },
        {
            element: <QuranPage/>,
            name: 'قران',
            path: "/Quran/:id"
        },
        {
            element: <Authentication/>,
            name: 'ورود/ثبت نام',
            path: "/Authentication"
        },
        {
            element: <KhoddamPage/>,
            name: 'خدمات خادمین',
            path: "/Khoddam"
        },
        {
            element: <LiveStream/>,
            name: 'پخش زنده',
            path: "/Live"
        },
        {
            element: <RegUser/>,
            name: 'ثبت نام خادم',
            path: "/RegUser"
        }
    ];
    return useRoutes(routes);
};
export default Router;
